module.exports = __webpack_public_path__ + "static/media/50d.44e78963.png";